/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_hint_p_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter an error probability between 0 and 1.`)
};

const es_phred_hint_p_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce una probabilidad de error entre 0 y 1.`)
};

const de_phred_hint_p_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine Fehlerwahrscheinlichkeit zwischen 0 und 1 ein.`)
};

const nl_phred_hint_p_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een foutkans tussen 0 en 1 in.`)
};

const fr_phred_hint_p_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez une probabilité d'erreur entre 0 et 1.`)
};

const it_phred_hint_p_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci una probabilità di errore tra 0 e 1.`)
};

const pt_br2_phred_hint_p_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe uma probabilidade de erro entre 0 e 1.`)
};

const pt_phred_hint_p_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza uma probabilidade de erro entre 0 e 1.`)
};

const ja_phred_hint_p_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0から1の間のエラー確率を入力してください。`)
};

const zh_phred_hint_p_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入 0 到 1 之间的错误概率。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_hint_p_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_hint_p_invalid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_hint_p_invalid", locale)
	if (locale === "en") return en_phred_hint_p_invalid(inputs)
	if (locale === "es") return es_phred_hint_p_invalid(inputs)
	if (locale === "de") return de_phred_hint_p_invalid(inputs)
	if (locale === "nl") return nl_phred_hint_p_invalid(inputs)
	if (locale === "fr") return fr_phred_hint_p_invalid(inputs)
	if (locale === "it") return it_phred_hint_p_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_phred_hint_p_invalid(inputs)
	if (locale === "pt") return pt_phred_hint_p_invalid(inputs)
	if (locale === "ja") return ja_phred_hint_p_invalid(inputs)
	return zh_phred_hint_p_invalid(inputs)
};